import ProductTag from "@pages/ProductListing/view/components/ProductTag";
import React, { useState } from "react";
import { inrFormat } from "@common/utils/formatCurrency";
import ProgressTracker from "../ProgressTracker";
import {
  retryPayment,
  paymentVerification,
  paymentFailed,
} from "@common/utils/cart";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import CloudinaryAdvancedImage from "@common/utils/CloudinaryAdvancedImage";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

function OrderCard({ status, orderDetails }) {
  const navigate = useNavigate();

  const handleBackdropClick = (event) => {
    // Prevent close when the backdrop is clicked
    event.stopPropagation();
  };

  const [open, setOpen] = useState(false);
  const [loadingRetryPayment, setLoadingRetryPayment] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleModalClose = (event, reason) => {
    // This is where you can handle close when clicking the modal button, etc.
    if (reason === "backdropClick") {
      // Do nothing to prevent closing on backdrop click
      return;
    }
    handleClose();
  };

  const handleRetryPayment = async () => {
    setLoadingRetryPayment(true);
    try {
      const retryResponse = await retryPayment(orderDetails.id);

      if (retryResponse && retryResponse.success) {
        const { paymentOrder } = retryResponse.data;
        handlePayment(
          paymentOrder.id,
          paymentOrder.amount,
          paymentOrder.currency,
          "UPI" // Default to UPI for retry
        );
      } else {
        // toast.error("Failed to retry payment. Please try again.");
      }
    } catch (error) {
      console.error("Error retrying payment:", error);
      // toast.error("Failed to retry payment. Please try again.");
    } finally {
      setLoadingRetryPayment(false);
    }
  };

  const handlePayment = async (
    order_id,
    amount,
    currency,
    paymentMethod = "UPI"
  ) => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount,
      currency,
      name: "Sansaar",
      image:
        "https://sansaar.co.in/static/media/logo.d3449133eb415c9b7652a3844a303205.svg",
      order_id,
      handler: async function (response) {
        try {
          const verificationResult = await paymentVerification(
            response.razorpay_order_id,
            response.razorpay_payment_id,
            response.razorpay_signature
          );
          if (verificationResult && verificationResult.success) {
            // toast.success("Payment successful! Your order has been updated.");
            // Refresh the page to show updated order status
            window.location.reload();
          } else {
            // Payment verification failed
            await paymentFailed(
              order_id,
              "VERIFICATION_FAILED",
              "Payment verification failed"
            );
            const queryParams = new URLSearchParams({
              orderId: order_id,
              amount: (amount / 100).toString(),
              paymentMethod: paymentMethod,
              reason: "Payment verification failed",
            });
            navigate(`/payment-failure?${queryParams.toString()}`);
          }
        } catch (error) {
          console.error("Payment verification error:", error);
          await paymentFailed(
            order_id,
            "VERIFICATION_ERROR",
            "Payment verification error"
          );
          const queryParams = new URLSearchParams({
            orderId: order_id,
            amount: (amount / 100).toString(),
            paymentMethod: paymentMethod,
            reason: "Payment processing error",
          });
          navigate(`/payment-failure?${queryParams.toString()}`);
        }
      },
      modal: {
        ondismiss: async function () {
          await paymentFailed(
            order_id,
            "MODEL_DISMISSED",
            "the user has dismissed the modal"
          );
          // Navigate to payment failure page with query parameters
          const queryParams = new URLSearchParams({
            orderId: order_id,
            amount: (amount / 100).toString(),
            paymentMethod: paymentMethod,
            reason: "Payment cancelled by user",
          });
          navigate(`/payment-failure?${queryParams.toString()}`);
        },
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#513117",
      },
      config: {
        display: {
          hide: [
            {
              method: "paylater",
            },
          ],
        },
      },
    };

    // Set payment method preferences
    options.method = {
      upi: true,
      netbanking: true,
      card: true,
      wallet: false,
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };

  //state dropdown
  const [state, setState] = useState("");

  const stateHandleChange = (event) => {
    setState(event.target.value);
  };

  return (
    <>
      <div className="bs-order-card">
        <div className="bs-order-card__head-wrap">
          {(status.toLowerCase() === "pending" ||
            status.toLowerCase() === "created" ||
            status.toLowerCase() === "ready_to_ship" ||
            status.toLowerCase() === "processing" ||
            status.toUpperCase() === "DISPATCHED") &&
            orderDetails?.paymentStatus !== "FAILED" && (
              <div className="bs-order-card__title-wrap">
                <h2 className="bs-order-card__title">
                  <span className="bs-order-card__title-text">
                    {status.toLowerCase() === "created"
                      ? "initiated"
                      : status.replace(/_/g, " ")}
                  </span>
                </h2>
                <ProgressTracker />
              </div>
            )}
          {status.toLowerCase() === "delivered" && (
            <div className="bs-order-card__title-wrap">
              <h2 className="bs-order-card__title">
                <span className="icon icon-check-circle bs-order-card__icon"></span>
                <span className="bs-order-card__title-text">{status}</span>
              </h2>
            </div>
          )}
          {status.toLowerCase() === "cancelled" && (
            <div className="bs-order-card__title-wrap">
              <h2 className="bs-order-card__title">
                <span className="icon icon-forbidden bs-order-card__icon"></span>
                <span className="bs-order-card__title-text">
                  order cancelled
                </span>
              </h2>
            </div>
          )}
          {orderDetails?.paymentStatus === "FAILED" && (
            <div className="bs-order-card__title-wrap">
              <h2 className="bs-order-card__title">
                <span className="icon icon-fail bs-order-card__icon"></span>
                <span className="bs-order-card__title-text">
                  payment failed
                </span>
              </h2>
            </div>
          )}
          {status === "cancelled" ? null : (
            <div className="bs-order-card__action-wrap">
              <ul className="bs-order-card__action-list">
                {(status === "pending" ||
                  status.toLowerCase() === "created" ||
                  status.toLowerCase() === "ready_to_ship" ||
                  status.toLowerCase() === "complete") && (
                    <li className="bs-order-card__action-item">
                      <button
                        className="bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline bs-address-card__button"
                        onClick={handleOpen}
                        type="button"
                        aria-label="Cancel order"
                      >
                        <span className="bs-btn__btn-text">cancel order</span>
                      </button>
                    </li>
                  )}
                {orderDetails?.paymentStatus === "FAILED" && (
                  <li className="bs-order-card__action-item">
                    <button
                      className="bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-sm"
                      onClick={handleRetryPayment}
                      disabled={loadingRetryPayment}
                      type="button"
                      aria-label={
                        loadingRetryPayment
                          ? "Processing payment"
                          : "Retry payment"
                      }
                    >
                      <span className="bs-btn__btn-text">
                        {loadingRetryPayment
                          ? "Processing..."
                          : "Retry Payment"}
                      </span>
                    </button>
                  </li>
                )}
                {status === "delivered" && (
                  <li className="bs-order-card__action-item">
                    <button
                      className="bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline bs-address-card__button"
                      type="button"
                      aria-label="Return or replace order"
                    >
                      <span className="bs-btn__btn-text">return/replace</span>
                    </button>
                  </li>
                )}
                {(status.toUpperCase() === "DISPATCHED" ||
                  status.toUpperCase() === "DELIVERED") && (
                    <li className="bs-order-card__action-item">
                      <a
                        href={orderDetails?.invoiceUrl}
                        rel="noreferrer"
                        target="_blank"
                        className="bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline bs-address-card__button"
                        aria-label="Download invoice"
                      >
                        <span className="icon icon-invoice-download bs-btn__icon"></span>
                        <span className="bs-btn__btn-text">download invoice</span>
                      </a>
                    </li>
                  )}
              </ul>
            </div>
          )}
        </div>
        <div className="bs-order-card__info-wrap">
          <div className="bs-order-card__order-info-wrap">
            <ul className="bs-order-card__order-info-data-wrap">
              <li className="bs-order-card__order-info-data-item">
                <label className="bs-order-card__order-info-data-label">
                  order id :
                </label>
                <p className="bs-order-card__order-info-data-value">
                  {orderDetails?.id}
                </p>
              </li>
              <li className="bs-order-card__order-info-data-item">
                <label className="bs-order-card__order-info-data-label">
                  placed on :
                </label>
                <p className="bs-order-card__order-info-data-value">
                  {orderDetails?.orderDate.split("T")[0]}
                </p>
              </li>
              <li className="bs-order-card__order-info-data-item">
                <label className="bs-order-card__order-info-data-label">
                  order total :
                </label>
                <p className="bs-order-card__order-info-data-value">
                  {inrFormat(orderDetails?.orderAmount)}
                </p>
              </li>
              <li className="bs-order-card__order-info-data-item">
                <label className="bs-order-card__order-info-data-label">
                  payment status :
                </label>
                <p
                  className={`bs-order-card__order-info-data-value ${orderDetails?.paymentStatus === "FAILED"
                    ? "bs-order-card__order-info-data-value--failed"
                    : ""
                    }`}
                >
                  {orderDetails?.paymentStatus}
                </p>
              </li>
              {orderDetails?.trackingNumber && (
                <li className="bs-order-card__order-info-data-item">
                  <label className="bs-order-card__order-info-data-label">
                    Tracking number : Delhivery -{" "}
                  </label>
                  <p className="bs-order-card__order-info-data-value">
                    {orderDetails?.trackingNumber}
                  </p>
                </li>
              )}
            </ul>
          </div>
          <div
            className={`bs-order-card__product-info-wrap ${status === "cancelled"
              ? "bs-order-card__product-info-wrap--no-bottom-border"
              : ""
              }`}
          >
            <ul className="bs-order-card__product-list">
              {orderDetails?.orderItem?.map((item, index) => {
                return (
                  <li className="bs-order-card__product-item">
                    <div className="bs-order-card__product">
                      <div className="bs-order-card__product-media-wrap">
                        <CloudinaryAdvancedImage
                          imagePublicId={item?.product?.imageUrl}
                          className="bs-order-card__product-image"
                          type="product-main"
                        />
                      </div>
                      <div className="bs-order-card__product-detail-wrap">
                        <label className="bs-order-card__product-type">
                          {item?.product?.sapCategoryName}
                        </label>
                        <h3 className="bs-order-card__product-title">
                          {item?.product?.name}
                        </h3>
                        <p className="bs-order-card__product-size-info">
                          <span className="bs-order-card__product-size-info--bold">
                            size :{" "}
                          </span>
                          {item?.product?.size} {item?.product?.dimensions}
                        </p>
                        <p className="bs-order-card__product-size-info">
                          <span className="bs-order-card__product-size-info--bold">
                            quantity :{" "}
                          </span>
                          {item?.quantity}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        {status === "cancelled" ? null : (
          <div className="bs-order-card__address-wrap">
            <label className="bs-order-card__address-wrap-title">
              delivering to
            </label>
            <div className="bs-order-card__cont-wrap">
              <div className="bs-order-card__address-title-wrap">
                <strong className="bs-order-card__address-title">
                  {orderDetails?.shippingAddress?.firstName}{" "}
                  {orderDetails?.shippingAddress?.lastName}
                </strong>
                <ProductTag
                  title={orderDetails?.shippingAddress?.tag}
                  classname="mod-product-tag--typ-border"
                />
              </div>
              <address className="bs-order-card__address-text">
                {orderDetails?.shippingAddress?.address}{" "}
                {orderDetails?.shippingAddress?.city} -{" "}
                {orderDetails?.shippingAddress?.state} -{" "}
                {orderDetails?.shippingAddress?.pincode}
              </address>
            </div>
          </div>
        )}
      </div>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bs-modal bs-modal--typ-select-address"
      >
        <Box
          className="bs-modal__wrapper"
          sx={style}
          onClick={handleBackdropClick}
        >
          <button
            className="bs-modal__close  bs-banner-form__close-btn"
            onClick={handleModalClose}
          >
            <span className="icon icon-simple-close"></span>
          </button>
          <div className="bs-success-msg">
            <div className="bs-success-msg__info-wrap">
              {/* <span className='icon icon-success bs-success-msg__icon'></span> */}
              {/* <h4 className='bs-success-msg__title'>Order placed successfully</h4> */}
              <p className="bs-success-msg__desc">
                Returns and Replacements are available for damaged products or
                manufacturing defects within 7 days of delivery. Order
                cancellations are applicable only for orders that are not
                dispatched. Write to us at{" "}
                <a href="mailto:support@sansaar.co.in" className="bs-link">
                  support@sansaar.co.in
                </a>
                &nbsp; or call our customer care at{" "}
                <a href="tel:+917208026067" className="bs-link">
                  +91 72080 26067
                </a>
                &nbsp; for any return, refund, or cancellation requests.
              </p>
            </div>
            {/* <div className='bs-success-msg__action-wrap'>
                        <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' onClick={handleModalClose}>continue shopping</button>
                    </div> */}
          </div>
        </Box>
      </Modal>

      {/* <Modal
            open={open}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className='bs-modal bs-modal--typ-form bs-modal--typ-order-cancel'
            
        >
            <Box className='bs-modal__wrapper' sx={style} onClick={handleBackdropClick}>
                <div className='bs-modal__content'>
                    <h2 className='bs-modal__title'>Forgot password</h2>
                    <p className='bs-modal__title-desc'>
                        Returns and Replacements are available for damaged products or manufacturing defects within 7 days of delivery. 
                        Order cancellations are applicable only for orders that are not dispatched. 
                        Write to us at <a href="mailto:support@sansaar.co.in" className="bs-link">support@sansaar.co.in</a> 
                        or call our customer care at <a href="tel:+917208026067" className="bs-link">+91 72080 26067</a> 
                        for any return, refund, or cancellation requests.
                    </p>
                    <form className='bs-form bs-form--typ-column'>
                        <div className={`bs-form__form-group`}>
                            <TextField
                            id="emailId"
                            name="emailId"
                            // value={signInFormik.values.username}
                            // onChange={signInFormik.handleChange}
                            // onBlur={signInFormik.handleBlur}
                            type="email"
                            label="Email Id"
                            className='bs-form__form-control'
                            />
                        </div>
                        <div className={`bs-form__form-bottom-wrap`}>
                            <div className='bs-form__form-bottom-wrap--col'>
                            <button 
                                className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl'
                                onClick={successHandleModalOpen}
                            >
                                Send resend link
                            </button>
                            </div>
                            <button className='bs-btn bs-btn__btn-link mod-text-btn__link' onClick={hideForgotPassWordFormHandle}>back to sign in</button>
                        </div>
                    </form>
                </div>
                <div className='bs-modal__content'>
                    <div className='bs-cancel-order'>
                        <div className='bs-cancel-order__head-wrap'>
                            <span className='bs-cancel-order__icon icon icon-forbidden'></span>
                            <h3 className='bs-cancel-order__title'>Are you sure you want to cancel selected order ?</h3>
                            <label className='bs-cancel-order__order-info'><span className='bs-cancel-order__order-info--bold'>order id :</span>121435195150135</label>
                        </div>
                        <form className='bs-form bs-form--typ-column bs-cancel-order__cont-wrap'>
                            <div className={`bs-form__form-group`}>
                                <div className={`bs-form__form-group`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label" required>select reason</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={state}
                                            label="select reason"
                                            onChange={stateHandleChange}
                                            // IconComponent={<span className='icon icon-expaand-more'></span>}
                                        >
                                            <MenuItem value={10}>Ten</MenuItem>
                                            <MenuItem value={20}>Twenty</MenuItem>
                                            <MenuItem value={30}>Thirty</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className={`bs-form__form-group`}>
                                <TextField 
                                    id="comments"
                                    name="comments"
                                    type="text"
                                    label="add comments" 
                                    className='bs-form__form-control bs-form__form-control--text-area' 
                                    multiline
                                    maxRows={5}
                                />
                            </div>
                            <div className={`bs-form__form-bottom-wrap`}>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl' type='submit' >yes, cancel</button>
                                <button className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-xxl bs-btn__btn-solid--inverse-border'>go back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Box>
        </Modal> */}
    </>
  );
}

export default OrderCard;
